import { useContext } from "react";
import { HouseCompetitionData } from "../contextProvider";
import { useCompetition } from "../../../../redux/features/categories/selectors";

const LastChance = () => {
  const houseData = useContext(HouseCompetitionData);
  const houseCompetition = useCompetition({
    CompetitionTypePrefix: "HC",
  });
  return (
    <div className={"flex flex-col justify-center items-center gap-2 self-stretch font-jost"}>
      <div className={"flex flex-col items-center gap-2 lg:gap-4"}>
        <div
          className={
            "text-[#28282B] text-center text-[32px] font-black leading-10 uppercase lg:text-white lg:[text-shadow:0_2px_4px_rgba(0,0,0,0.70)] lg:text-[42px] lg:leading-[56px] 2xl:text-[40px] 2xl:leading-[50px]"
          }>
          {houseCompetition.FeaturedPrizeModel}
          {/*LAST CHANCE! A £1.25M luxury dream home in Essex!*/}
        </div>
      </div>
      <div
        className={
          "text-[#4C4C52] text-center text-[22px] font-normal leading-7 lg:text-white lg:[text-shadow:0_2px_4px_rgba(0,0,0,0.70)] lg:text-[28px] lg:leading-8"
        }>
        Or take {houseData.cashAlternativeText} in Cash
      </div>
    </div>
  );
};

export default LastChance;
